import { FunctionComponent, PropsWithChildren, SVGProps } from 'react';
import classnames from 'classnames';

import styles from './IconWithNotifications.module.scss';

interface IIconWithNotifications {
  Svg?: FunctionComponent<
    SVGProps<SVGSVGElement> & { title?: string | undefined }
  >;
  showBadge: boolean;
  className?: string;
  notificationClassName?: string;
}

export default function IconWithNotifications({
  className,
  Svg,
  showBadge,
  notificationClassName,
  children,
}: PropsWithChildren<IIconWithNotifications>): JSX.Element {
  return (
    <div className={classnames(styles.IconWithNotifications, className)}>
      {showBadge && (
        <div
          className={classnames(styles.notification, notificationClassName)}
        />
      )}
      {Svg && <Svg className={styles.icon} />}
      {children}
    </div>
  );
}
